import api from "./api";

/**
 * Busca todos os payments (sem paginação). Acesso Sys.
 */
export function fetchPayments() {
  return api.get("/Payments");
}

/**
 * Busca um payment pelo seu ID.
 * @param {number} id
 */
export function getPaymentById(id) {
  return api.get(`/Payments/${id}`);
}

/**
 * Busca payments de um usuário específico.
 * @param {number} userId
 */
export function fetchPaymentsByUserId(userId) {
  return api.get(`/Payments/user/${userId}`);
}

/**
 * Busca payments de forma paginada com filtros opcionais aplicados no backend.
 * Todos os campos são enviados como query params — valores vazios são ignorados.
 *
 * @param {number} pageNumber
 * @param {number} pageSize
 * @param {object} filters - { paymentId, subscriptionId, userId, status, mpPaymentId, couponCodeSnapshot, paymentMethod }
 */
export function fetchPaymentsPaged(pageNumber, pageSize, filters = {}) {
  const params = { pageNumber, pageSize };

  if (filters.paymentId?.trim()) params.paymentId = filters.paymentId.trim();
  if (filters.subscriptionId?.trim())
    params.subscriptionId = filters.subscriptionId.trim();
  if (filters.userId?.trim()) params.userId = filters.userId.trim();
  if (filters.status?.trim()) params.status = filters.status.trim();
  if (filters.mpPaymentId?.trim())
    params.mpPaymentId = filters.mpPaymentId.trim();
  if (filters.couponCodeSnapshot?.trim())
    params.couponCodeSnapshot = filters.couponCodeSnapshot.trim();
  if (filters.paymentMethod?.trim())
    params.paymentMethod = filters.paymentMethod.trim();

  return api.get("/Payments/paged", { params });
}

/**
 * Cria um payment manualmente. Acesso Sys.
 * @param {object} data - PaymentCreateDto
 */
export function createPayment(data) {
  return api.post("/Payments", data);
}

/**
 * Atualiza um payment existente. Acesso Sys.
 * @param {object} data - PaymentUpdateDto (deve conter paymentId)
 */
export function updatePayment(data) {
  return api.put(`/Payments/${data.paymentId}`, data);
}

/**
 * Remove um payment pelo ID. Acesso Sys.
 * @param {number} id
 */
export function deletePayment(id) {
  return api.delete(`/Payments/${id}`);
}

/**
 * Remove múltiplos payments em lote. Acesso Sys.
 * @param {number[]} ids
 */
export function deletePaymentsBatch(ids) {
  return api.delete("/Payments", { data: ids });
}
